export default {
  imprint: "Impressum",
  "imprint.represented-by": "Vertreten durch die Geschäftsführer:",
  "imprint.registration-commercial-register": "Eintragung im Handelsregister:",

  "imprint.contact": "Kontakt",
  "imprint.contact-form": "Kontaktformular:",
  "imprint.contact-form.click": "Hier klicken",
  "imprint.general": "Allgemein:",
  "imprint.jobs": "Jobs:",
  "imprint.phone": "Telefon",
  "imprint.fax": "Fax",
  "imprint.data-protection-officer": "Kontakt Datenschutzbeauftragter",
  "imprint.data-protection-authority": "Datenschutzaufsichtsbehörde",
  "imprint.responsibility":
    "Verantwortlicher i.S.d. § 55 Abs. 2 RStV für die journalistisch-redaktionellen Inhalte: Avelios Medical GmbH (Anschrift wie oben).",
  "imprint.note":
    "Hinweis gem. ODR-Verordnung: Die Europäische Kommission stellt eine Plattform zur Online- Streitbeilegung bereit, die Sie unter https://ec.europa.eu/consumers/odr finden. Wir sind jedoch nicht bereit und verpflichtet an der Online-Streitbeilegung teilzunehmen.",
};
